import { render, staticRenderFns } from "./NuevoOdontograma.vue?vue&type=template&id=60e4ef34&scoped=true"
import script from "./NuevoOdontograma.vue?vue&type=script&lang=js"
export * from "./NuevoOdontograma.vue?vue&type=script&lang=js"
import style0 from "./NuevoOdontograma.vue?vue&type=style&index=0&id=60e4ef34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e4ef34",
  null
  
)

export default component.exports